(function () {
  const selector = '.collection__infinite-container';

  function orderProducts(container) {
    if (!container || container.dataset.stockOrderBusy === 'true') return;

    const products = Array.from(container.children).filter((item) =>
      item.classList.contains('product-item')
    );
    if (products.length < 2) return;

    const ordered = products.filter((item) => item.dataset.productAvailable === 'true')
      .concat(products.filter((item) => item.dataset.productAvailable !== 'true'));

    const alreadyOrdered = products.every((item, index) => item === ordered[index]);
    if (alreadyOrdered) return;

    container.dataset.stockOrderBusy = 'true';
    const fragment = document.createDocumentFragment();
    ordered.forEach((item) => fragment.appendChild(item));
    container.appendChild(fragment);
    delete container.dataset.stockOrderBusy;
  }

  function watchContainer(container) {
    if (container.dataset.stockOrderWatching === 'true') return;
    container.dataset.stockOrderWatching = 'true';
    orderProducts(container);

    const observer = new MutationObserver(() => orderProducts(container));
    observer.observe(container, { childList: true });
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(watchContainer);
  }

  document.addEventListener('collection:updated', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
